(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["postcode-checker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {

    let delivery_charges = "";
    let delivery_day = "";

    const fetchDeliveryCost = async (postcode) => {
      try {
        const response = await fetch(
          'https://cdn.shopify.com/s/files/1/0857/1358/4415/files/deliverycharges.json'
        );
        const data = await response.json();

        const entry = data.find((item) => item.postcode === postcode);

        if (entry && entry.delivery_charges !== "Sorry! We don't deliver here.") {
          return {
            delivery_charges: entry.delivery_charges,
            delivery_day: entry.delivery_day !== "N/A" ? entry.delivery_day : 'Not available',
          };
        } else {
          return { error: "Sorry! We don't deliver here." };
        }
      } catch (error) {
        console.error('Error fetching delivery cost:', error);
        return { error: 'Not available' };
      }
    };

    const renderDeliveryCost = async (postcode) => {
      const result = await fetchDeliveryCost(postcode);
      const deliveryDayResult = document.getElementById('delivery-day-result');
      const deliveryCostResult = document.getElementById('delivery-cost-result');

      if (result.error) {
        deliveryDayResult.textContent = ``;
        deliveryCostResult.textContent = result.error;
      } else {
        deliveryDayResult.textContent = `We deliver to your area (${postcode}) on: ${result.delivery_day}`;
        deliveryCostResult.textContent = `Delivery Charge: £${result.delivery_charges}`;
      }
    };

    const postcodeForm = document.getElementById('postcode-form');
    postcodeForm.addEventListener('submit', async (event) => {
      event.preventDefault(); // Prevent form submission
      const postcodeInput = document.getElementById('postcode-input').value.trim().toUpperCase();

      if (postcodeInput !== '') {
        await renderDeliveryCost(postcodeInput);
      } else {
        alert('Please enter a valid postcode.');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-honeypot"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.why-honeypot__tab');
  const contents = document.querySelectorAll('.why-honeypot__content');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));

      tab.classList.add('active');
      document.getElementById(target).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
